import React, { useState, useEffect, useRef } from "react";

const MessageList = ({ messages }) => {
  const messagesEndRef = useRef(null);

  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages]);

  return (
    <div className="space-y-2 overflow-y-auto max-h-72 p-2 bg-gray-50 rounded-lg shadow-inner">
      {messages.map((message, index) => (
        <div
          key={index}
          className={`p-3 rounded-lg shadow-md ${
            message.isMine
              ? "bg-blue-500 text-white ml-auto"
              : "bg-gray-200 text-gray-800 mr-auto"
          } w-max max-w-xs`}
        >
          <p className="text-sm font-semibold mb-1">
            {typeof message.sender === "object"
              ? `${message.sender.firstName ?? ""} ${message.sender.lastName ?? ""}`.trim() || "Unknown"
              : message.sender ?? "Unknown"}
            :
          </p>
          <p>{message.content}</p>
        </div>
      ))}
      <div ref={messagesEndRef} />
    </div>
  );
};

export default MessageList;